export const LIST_COMPONENT_MASONRY = 'PostListMasonry';
export const LIST_COMPONENT_SIMPLE = 'PostListSimple';
export const LIST_COMPONENT_MOBILE = 'PostListMobile';
export const ITEM_COMPONENT_LIST_ITEM = 'PostListItem';
export const ITEM_COMPONENT_MOBILE_SIDE_BY_SIDE = 'SideBySideMobile';
export const ITEM_COMPONENT_MOBILE_TOI = 'TextOnImageMobile';
export const ITEM_COMPONENT_POST = 'Post';
//# sourceMappingURL=post-list-components.js.map